export { default } from './ResponsiveProductPAModal'
